// extracted by mini-css-extract-plugin
export var heroHeaderLeft = "t_sj d_gv d_cs";
export var heroHeaderCenter = "t_gw d_gw d_cs d_dw";
export var heroHeaderRight = "t_gx d_gx d_cs d_dx";
export var heroParagraphLeft = "t_sk d_gr d_cw";
export var heroParagraphCenter = "t_gs d_gs d_cw d_dw";
export var heroParagraphRight = "t_gt d_gt d_cw d_dx";
export var heroBtnWrapperLeft = "t_sl d_d2 d_d1 d_w d_bz d_bG";
export var heroBtnWrapperCenter = "t_sm d_d3 d_d1 d_w d_bz d_bD";
export var heroBtnWrapperRight = "t_sn d_d4 d_d1 d_w d_bz d_bH";
export var overlayBtnWrapper = "t_sp d_gq d_0 d_7 d_8 d_9 d_bn d_cc";
export var design4 = "t_sq d_gp d_0 d_7 d_8 d_bn";
export var heroExceptionSmall = "t_sr z_sr";
export var heroExceptionNormal = "t_ss z_ss";
export var heroExceptionLarge = "t_st z_st";
export var Title1Small = "t_sv z_sv z_tb z_tc";
export var Title1Normal = "t_sw z_sw z_tb z_td";
export var Title1Large = "t_sx z_sx z_tb z_tf";
export var BodySmall = "t_sy z_sy z_tb z_tv";
export var BodyNormal = "t_sz z_sz z_tb z_tw";
export var BodyLarge = "t_sB z_sB z_tb z_tx";